<label *ngIf="topLabel" [for]="id" class="core_input_top_label">{{topLabel}}</label>
<div class="core-input-label-container">
  <label *ngIf="label">{{label}}</label>
  <div class="p-inputgroup core-input-container core_input_flex_between">
    <input
      (keyup.enter)="onKeyUpEnter.emit(value)"
      (ngModelChange)="valueChanged($event)"
      [attr.type]="enableBrowserSuggestion || value?.length >= 1 ? 'password': 'text'"
      [disabled]="disabled"
      [id]="id"
      [ngClass]="control.touched && control.errors ? 'core_input_invalid' : ''"
      [ngModel]="value"
      [placeholder]="placeholder"
      [style]="{width: showClearButton ? 'calc(100% - 40px)' : '100%'}"
      class="core-input"
      pInputText>
    <button
      (click)="onClear()"
      *ngIf="showClearButton"
      [disabled]="disabled"
      class="p-button-secondary core-input-button-clear p-inputgroup-addon"
      icon="pi pi-times"
      pButton
      tabindex="-1">
    </button>
  </div>
</div>
<div
  [ngClass]="[label ? 'core_input_error_container_with_label' : '', removeDefaultBottomErrorMargin ? '' : 'core_input_error_container_min_height']"
  class="core_input_error">
  <small *ngIf="control.touched && control.errors?.required">
    Dieses Feld ist erforderlich!
  </small>
  <small *ngIf="control.touched && control.errors?.noLowerCaseCharacter">
    Es muss mindestens ein Kleinbuchstabe enthalten sein!
  </small>
  <small *ngIf="control.touched && control.errors?.noUpperCaseCharacter">
    Es muss mindestens ein Großbuchstabe enthalten sein!
  </small>
  <small *ngIf="control.touched && control.errors?.noNumber">
    Es muss mindestens eine Zahl enthalten sein!
  </small>
  <small *ngIf="control.touched && control.errors?.minlength">
    Dieses Feld muss mindestens {{control.errors.minlength.requiredLength}} Zeichen lang sein!
  </small>
  <small *ngIf="control.touched && control.errors?.maxlength">
    Dieses Feld darf maximal {{control.errors.maxlength.requiredLength}} Zeichen lang sein!
  </small>
  <small *ngIf="control.touched && control.errors?.doesNotMatch">
    Die angegebenen Passwörter stimmen nicht überein!
  </small>
</div>
